import apiService from '../apiService'
export const dashboardController = configService => {
  const service = apiService(configService)
  return {
    getQtyStatus: params => {
      return service.get({
        url: `cms/buyer/event/qty`,
        params,
      })
    },

    getSupplierQtyStatus: params => {
      return service.get({
        url: `cms/supplier/dashboard`,
        params,
      })
    },
  }
}
